import React, { Component } from "react";
import "../../assests/css/Home.css";
import Slider from "react-slick";
import "../../assests/css/Slider_custom.css";
import { Link } from "react-router-dom";
// import SampleNextArrow from '../../Components/Slider/SampleNextArrow';
// import SamplePrevArrow from '../../Components/Slider/SamplePrevArrow';

const TopSlider = () => {
  let arr = [0, 1, 2];

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className="Slider_top_custom_arrows-next"
        // style={{ ...style, display: "block", background: "red" }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { style, onClick } = props;
    return (
      <div
        className="Slider_top_custom_arrows"
        // style={{ ...style, display: "block", background: "green" }}
        onClick={onClick}
      />
    );
  }

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    // vertical: true,
    // verticalSwiping: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

    // nextArrow: <SampleNextArrow />,
    // prevArrow: <SamplePrevArrow />,
    appendDots: (dots) => (
      <div
        style={{
          backgroundColor: "transparent",
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <ul style={{ margin: "0px" }}> {dots} </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
      // style={{
      //     backgroundColor: "black",
      //     width: "30px",
      //     color: "blue",
      //     border: "1px blue solid"
      // }}
      // {`${title == "home" ? "white" : "black"}`}
      >
        <span>{i + 1}</span>
      </div>
    ),
  };

  const handleBooking = () => {
    // window.location.replace("https://eb3.autocab.net/#/33710");
    window.open("https://eb3.autocab.net/#/33710", "_blank");
  };

  return (
    <div className="top-home-slider-sec">
      <div className="container mb-cus-slider">
        <Slider {...settings}>
          {arr.map((item, index) => {
            return (
              <div key={index}>
                <div className="row">
                  <div className="col-lg-7 mt-4 mb-3">
                    {/* <div className='number'>

                                        </div> */}
                    <span className="f-pop-semibold f-80 clr-gry">
                      +441279 247 247
                    </span>
                  </div>
                  <div className="col-lg-5 text-end mt-4 mb-3 res-mrgn-topslider">
                    <div className="powered_by_img"></div>
                  </div>
                  <div className="col-md-5 p-3">
                    <p className="f-20 blkclr lh-05 f-pop-med">Metro 24 x 7</p>
                    <p className="blkclr f-20 lh-1 f-pop-med mt-2">
                      {" "}
                      <span className="red-clr f-47 f-pop-semibold">
                        Quick
                      </span>{" "}
                      and Reliable Taxi 24x7 Services{" "}
                    </p>
                    <p className="txt-gr-sml my-4 f-pop-med lh-02 f-15">
                      Metro 24 x 7 is a reliable airport transfer services
                      dedicated to ensuring the safety and satisfaction of our
                      clients by offering prompt assistance and ease of booking.
                      Whether you need immediate service to drop you at the
                      airport or need a ride to get back to your place from the
                      airport, you will have the leading stansted airport
                      transfers’ full support.
                    </p>
                    {/* <Link to="/booking" className="link_ourfleet">
                      <button className="btn btn-danger red-clr-btn p-bt-cus f-pop-med f-14">
                        Book Now
                      </button>
                    </Link> */}
                    <a className="link_ourfleet">
                      <button
                        className="btn btn-danger red-clr-btn p-bt-cus f-pop-med f-14"
                        onClick={handleBooking}
                      >
                        Book Now
                      </button>
                    </a>
                  </div>
                  <div className="col-md-7">
                    <div className="car-img-box">
                      <div className="bg-car-img"></div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};

export default TopSlider;
